import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, HardHat, Wrench } from "lucide-react";
import { MAJOR_PROJECTS, HOME_SERVICES } from "../../content/hubs";

// Two-path chooser directly under the hero: Major Projects vs Home Services.
export const PathCards = () => {
  const cards = [
    {
      key: "major-projects",
      icon: HardHat,
      title: "Major Renovations",
      blurb: "Additions, remodels, demolition, and custom home building — coordinated by a general contractor.",
      href: "/sc/major-projects/",
      items: MAJOR_PROJECTS,
    },
    {
      key: "home-services",
      icon: Wrench,
      title: "Home Services",
      blurb: "HVAC, plumbing, roofing, flooring, lawn care, and more — handled by local specialists.",
      href: "/sc/home-services/",
      items: HOME_SERVICES,
    },
  ];
  return (
    <section data-testid="path-cards" className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.a
                key={c.key}
                href={c.href}
                data-testid={`path-card-${c.key}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="group relative overflow-hidden rounded-[1.5rem] bg-[#133955] text-white p-8 md:p-10 hover:shadow-[0_24px_60px_rgba(19,57,85,0.28)] transition-shadow duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54BCE6] focus-visible:ring-offset-2"
              >
                <div className="pointer-events-none absolute -top-16 -right-16 h-56 w-56 rounded-full bg-[#54BCE6]/20 blur-3xl" />
                <span className="grid place-items-center w-12 h-12 rounded-full bg-white/15 border border-white/20 text-[#54BCE6]">
                  <Icon size={22} />
                </span>
                <h2 className="mt-6 font-display text-3xl md:text-4xl font-bold tracking-tight">{c.title}</h2>
                <p className="mt-3 text-white/75 leading-relaxed max-w-md">{c.blurb}</p>
                <p className="mt-4 text-sm text-white/55">
                  {c.items.map((p) => p.name).join(" · ")}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 font-bold text-[#54BCE6]">
                  Explore {c.title}
                  <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
